module.exports = __webpack_public_path__ + "img/avatar.540b988c.png";